@if (data?.content?.tiles?.length) {
  <div class="container max-width">
    @for (item of data.content.tiles; track item) {
      <app-equity-tile-item [tile]="item"></app-equity-tile-item>
    }
  </div>
}
